import api from './api';

// M1084: Setting → Physical Branches (Testing Account flag).
class PhysicalBranchService {
  getList(dataForm) {
    return api.post('/merchant/physical-branches', dataForm);
  }

  updateTesting(id, isTesting) {
    return api.post('/merchant/physical-branches/update-testing/' + id, {
      is_testing: isTesting ? 1 : 0,
    });
  }
}

export default new PhysicalBranchService();
